import { render } from "./stories-block.vue?vue&type=template&id=4518baf4"
import script from "./stories-block.vue?vue&type=script&lang=js"
export * from "./stories-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__